import { BookingsQueryParams, IFlowApiAdapter } from './flow-api-adapter/types';
import { BookingsDataCapsule } from '@wix/bookings-data-capsule';
import { FormValues } from '@wix/form-viewer';

export function getSessionValues<T = any>(
  wixSdkAdapter: IFlowApiAdapter,
  key: BookingsQueryParams,
): T | undefined {
  const valueFromStorage = wixSdkAdapter.getFromSessionStorage(key);

  if (valueFromStorage) {
    return JSON.parse(valueFromStorage);
  }

  return undefined;
}

export async function getFieldsValuesInStorage(
  bookingsDataCapsule: BookingsDataCapsule,
  key: BookingsQueryParams,
): Promise<Maybe<FormValues>> {
  return bookingsDataCapsule.getItem(key);
}

export async function setFieldsValuesInStorage(
  bookingsDataCapsule: BookingsDataCapsule,
  wixFormValues: FormValues,
) {
  if (wixFormValues) {
    try {
      await bookingsDataCapsule.setItem(
        BookingsQueryParams.WIX_FORM_VALUES,
        wixFormValues,
      );
    } catch (e) {
      console.error('data capsule set value error', e);
    }
  }
}
